import { collection, doc, getFirestore, addDoc, updateDoc, onSnapshot } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import PrimaryButton from '../components/buttons/PrimaryButton';
import Input from '../components/inputs/Input';
import SelectInput from '../components/inputs/SelectInput';
import { app } from '../firebase'; // Importez votre configuration Firebase
import { useUser } from '../contexts/UserContext';
import CheckboxInput from '../components/inputs/CheckboxInput';
import { isRentalManager } from '../contexts/UserContext';

const db = getFirestore(app);

const accountLabel = (account) => {
  const name = `${account.firstname || ""} ${account.lastname || ""}`.trim();
  return [account.company, name, account.email].filter(Boolean).join(" — ");
};

function AddProvider({onClose, provider=null}) {

  //contexte de l'utilisateur connecté
  const user = useUser();

  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");
  
  const [email, setEmail] = useState(provider !== null ? provider.email : "");
  const [email2, setEmail2] = useState(provider !== null ? provider?.email2 !== undefined ? provider.email2 : "" : "");
  const [phone, setPhone] = useState(provider !== null ? provider.phone : "");
  const [name, setName] = useState(provider !== null ? provider.name : "");
  const [type, setType] = useState(provider !== null ? provider.type : "");
  const [coownershipComiteeTarget, setCoownershipComiteeTarget] = useState(provider !== null ? provider.coownershipComiteeTarget : (isRentalManager(user.user) ? false : true)); 
  const [coownerTarget, setCoownerTarget] = useState(provider !== null ? provider.coownerTarget : false); 
  const [tenantTarget, setTenantTarget] = useState(provider !== null ? provider.tenantTarget : (isRentalManager(user.user) ? true : false)); 
  const [userProviderId, setUserProviderId] = useState(provider?.userProviderId ?? "");
  const [providerAccounts, setProviderAccounts] = useState([]);

  const [errors, setErrors] = useState({
    phone: '',
    email: '',
    email2: '',
    name: '',
    type: '',
  });

  useEffect(() => {
    const coownershipPath = user.user.userData.lastCoownershipLoaded?.path;
    if (!coownershipPath) {
      return undefined;
    }

    const unsubscribe = onSnapshot(collection(db, coownershipPath + "/usersProvider"), (snapshot) => {
      const accounts = snapshot.docs.map((account) => ({
        id: account.id,
        firstname: account.data().firstname ?? "",
        lastname: account.data().lastname ?? "",
        company: account.data().company ?? "",
        email: account.data().email ?? "",
      }));

      accounts.sort((a, b) => accountLabel(a).localeCompare(accountLabel(b), "fr"));
      setProviderAccounts(accounts);
    });

    return () => unsubscribe();
  }, [user.user.userData.lastCoownershipLoaded?.path]);

  const resetState = () => {
    setError("");
    setEmail("");
    setEmail2("");
    setName("");
    setPhone(""); 
    setType("");
    setUserProviderId("");
  }

  const providerPayload = () => ({
    email: email,
    email2: email2,
    phone: phone,
    name: name,
    type: type,
    coownershipComiteeTarget: coownershipComiteeTarget,
    coownerTarget: coownerTarget,
    tenantTarget: tenantTarget,
    userProviderId: userProviderId || null,
  });

  const handleSubmit = async (e)  => {
    e.preventDefault();
    console.log("submit provider");
    
    // Validation des champs
    const newErrors = {};

    if (!email) {
      newErrors.email = "L'email est requis.";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "L'email est invalide.";
    }

    console.log("email2 : "+ email2)

    if(email2 !== "" && !/\S+@\S+\.\S+/.test(email2)) {
      newErrors.email2 = "Le second email est invalide.";
    }

    if (!name) {
      newErrors.name = "Le nom de la société est requis.";
    }

    if (!type) {
      newErrors.type = "Le type de service proposé par la société est requis.";
    }

    if (Object.keys(newErrors).length === 0) {
      console.log("Données du formulaire valides.");

      try{
        setLoader(true);
        
        if(provider !== null){ //on update

          //on envoie les données sur firestore 
          const providerDoc = doc(db, user.user.userData.lastCoownershipLoaded.path+"/providers/"+provider.id);

          await updateDoc(providerDoc, providerPayload());

        }else{
          //on envoie les données sur firestore 
          const providersCollection = collection(db, user.user.userData.lastCoownershipLoaded.path+"/providers");

          await addDoc(providersCollection, providerPayload());
        }


        setLoader(false);
        //on remet tous les states par défaut
        resetState(); 

        //on close la popup
        onClose(); 

      } catch(err){
        console.log(err)
        setError("Une erreur est survenue, impossible d'ajouter le prestataire");
        setLoader(false);
      }
    } else {
      // Afficher les erreurs
      setErrors(newErrors);
    }
  };


  return (
    <div id="authentication-modal" tabindex="-1" aria-hidden="true" className="mx-auto w-full fixed inset-0 flex items-center justify-center overflow-auto">
      <div className="relative w-full max-w-md max-h-full">
        <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <button type="button" onClick={onClose} className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white" data-modal-hide="authentication-modal">
            <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
            </svg>
            <span className="sr-only">Close modal</span>
          </button>
          <div className="px-6 py-6 lg:px-8">
            <h3 className="mb-4 text-xl font-medium text-gray-900 dark:text-white">Ajouter un prestataire</h3>

            <form onSubmit={handleSubmit}>

              <div className='mb-6'>

                <div className='border-b border-gray mt-0.5 mb-2'></div>
                  <Input id={"name"} label={"Nom de la société"} type={"text"} name={"name"} value={name} onChange={(event) => setName(event.target.value)} error={errors.name} />
                  <Input id={"type"} label={"Type de services"} type={"text"} name={"type"} value={type} onChange={(event) => setType(event.target.value)} error={errors.type} />
                  <Input id={"email"} label={"Email du prestataire"} type={"email"} name={"email"} value={email} onChange={(event) => setEmail(event.target.value)} error={errors.email} />
                  <Input id={"email2"} label={"Email du prestataire (2ème adresse)"} type={"email"} name={"email2"} value={email2} onChange={(event) => setEmail2(event.target.value)} error={errors.email2} required={false} />
                  <Input id={"phone"} label={"Téléphone du prestataire"} type={"phone"} name={"phone"} value={phone} onChange={(event) => setPhone(event.target.value)} error={errors.phone} required={false} />

                  <SelectInput
                    id={"userProviderId"}
                    name={"userProviderId"}
                    label={"Compte prestataire lié"}
                    value={userProviderId}
                    onChange={(event) => setUserProviderId(event.target.value)}
                    required={false}
                    placeholder={"Aucun compte"}
                  >
                    {providerAccounts.map((account) => (
                      <option key={account.id} value={account.id}>
                        {accountLabel(account)}
                      </option>
                    ))}
                    {userProviderId && !providerAccounts.some((account) => account.id === userProviderId) ? (
                      <option value={userProviderId}>Compte lié ({userProviderId})</option>
                    ) : null}
                  </SelectInput>
                  
                  
                  <div className='flex'>
                    <label className="block text-sm font-medium text-gray-700">
                      Cibles autorisées à soumettre des demandes
                    </label>
                    <label className='text-red-500'> *</label>
                  </div>
                  <div className='flex justify-between'>
                    <CheckboxInput  id={"coownershipComiteeTarget"} name={"coownershipComiteeTarget"} label={"CS"} checked={coownershipComiteeTarget} onChange={() => setCoownershipComiteeTarget(!coownershipComiteeTarget)} disabled={isRentalManager(user.user)}/>
                    <CheckboxInput  id={"coownerTarget"} name={"coownerTarget"} label={"Copropriétaires"} checked={coownerTarget} onChange={() => setCoownerTarget(!coownerTarget)} disabled={isRentalManager(user.user)}/>
                    <CheckboxInput  id={"tenantTarget"} name={"tenantTarget"} label={"Locataires"} checked={tenantTarget} onChange={() => setTenantTarget(!tenantTarget)} disabled={isRentalManager(user.user)}/>
                  </div>
                </div>

                <div className="text-center">
                  <PrimaryButton type={"submit"} value={provider !== null ? "Modifier" : "Ajouter"} loading={loader} />
                </div>

                {error !== "" ? (
                  <p className='justify-center flex my-1 text-red-500'>{error}</p>
                ) : null}
              
            </form>

          </div>
        </div>
      </div>
    </div> 
  );
}

export default AddProvider;